/**
 * Custom Hook: useFilteredCrops
 * Manages crop filtering and categorization logic
 * Uses memoization to optimize performance with multiple re-renders
 * 
 * @param {Array<Object>} crops - Array of crop objects to filter
 * @param {string} searchTerm - Search term to filter crops by name/pest
 * @param {string} selectedCategory - Category filter (use 'all' for no category filter)
 * @returns {Object} Object containing categories array, filteredCrops array, and count
 */

import { useMemo } from 'react';
import { filterCrops, getCategories } from '../utils/cropHelpers';

export const useFilteredCrops = (crops, searchTerm, selectedCategory) => {
  const categories = useMemo(() => getCategories(crops), [crops]);

  const filteredCrops = useMemo(
    () => filterCrops(crops, searchTerm, selectedCategory),
    [crops, searchTerm, selectedCategory]
  );

  return {
    categories,
    filteredCrops,
    count: filteredCrops.length,
  };
};
